export interface PortalUrlParams {
    jobItem: { itemId: number };
    proposalItem: { itemId: string };
    invoiceItem: { invoiceId: string };
    consolidateInvoiceItem: { consolidatedInvoiceId: string };
    estimateItem: { proposalId: string; estimateId: number };
    membershipItem: { itemId: number };
    serviceAgreementItem: { itemId: number };
    serviceAgreementItemEsign: { itemId: number };
    serviceAgreementVisitItem: { itemId: number; visitId: number };
}

export interface PortalQueryParams {
    invoices: {
        /** membership id */
        mid?: number;

        /** membership name */
        mn?: string;

        /** service address ids */
        aid?: number[];

        /** selected customer id */
        cid?: number;

        /** service agreement id */
        said?: number;
    };
    jobs: {
        /** service agreement id */
        said?: number;

        /** opens the jobs list with a specific view selected (e.g. 'unscheduled' = Upcoming tab + Unscheduled toggle) */
        view?: 'unscheduled';
    };
}

export const PortalUrls = {
    jobs: {
        root: '/jobs',
        item: '/:itemId',
    },
    invoices: {
        root: '/invoices',
        list: '/',
        item: '/:invoiceId',
        consolidatedInvoiceItem: '/consolidatedInvoice/:consolidatedInvoiceId',
    },
    paymentMethods: {
        root: '/payment-methods',
        list: '/',
    },
    proposals: {
        root: '/proposals',
        estimate: '/:proposalId/e/:estimateId',
        item: '/:itemId',
    },
    memberships: {
        rootMembership: '/memberships',
        rootContracts: '/contracts',
        item: '/:itemId',
    },
    equipment: {
        root: '/equipment',
    },
    serviceAgreements: {
        root: '/service-agreements',
        item: '/:itemId',
        esign: '/:itemId/esign',
        visitsList: '/:itemId/visits',
        visitsItem: '/:itemId/visits/:visitId',
        equipmentList: '/:itemId/equipment',
    },
};
